var generateStyle = function generateStyle(componentTheme) {
  return {
    globalStyles: {
      'body.tox-fullscreen .quizEntryEdit': {
        transform: 'none',
        zIndex: '6666'
      }
    },
    quizEntryEdit: {
      fontSize: componentTheme.quizEntryEditFontSize,
      position: 'relative',
      transform: 'translate3d(0, 0, 0)' /* for drag and drop preview to work */,
      margin: "".concat(componentTheme.quizEntryEditMargin, " 0"),
      zIndex: '3333'
    }
  };
};
export default generateStyle;